import script from "./BlocklyEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BlocklyEditor.vue?vue&type=script&setup=true&lang=js"

import "./BlocklyEditor.vue?vue&type=style&index=0&id=eeea08dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeea08dc"]])

export default __exports__